<template>
    <fragment>
        <router-view />
        <app-toast-host />
    </fragment>
</template>

<script>
import { mapActions } from "vuex";

import { ENABLED_AUTH } from "@/common/constants";

import AppToastHost from "@/components/utils/AppToastHost.vue";

export default {
    name: "App",
    components: { AppToastHost },
    data: () => ({
        prompt: false
    }),
    mounted() {
        const user = this.$store.state.auth?.user;
        if (user?.sub) {
            this.$analytics.identifyUser(user.sub, {
                $email: user.email,
                $name: [user.name, user.lastName].filter(Boolean).join(" ")
            });
        }

        if (this.$workbox) {
            this.$workbox.addEventListener("waiting", () => {
                this.prompt = true;
                this.$toast.show({
                    title: "Existe una nueva versión de la aplicación",
                    text: "Actualiza para obtener las últimas mejoras.",
                    icon: "🔄",
                    persistent: true,
                    position: "bottom-center",
                    action: {
                        label: "Actualizar",
                        handler: this.updateVersion
                    }
                });
            });
        }
        if (!ENABLED_AUTH) {
            this.applyPermissions();
        }
    },
    methods: {
        ...mapActions("auth", ["applyDefaultUser"]),
        async updateVersion() {
            this.prompt = false;
            await this.$workbox.messageSW({ type: "SKIP_WAITING" });
        },
        async applyPermissions() {
            this.applyDefaultUser();
        }
    }
};
</script>
